// extracted by mini-css-extract-plugin
export default {"wrapper":"CategoriesList_wrapper__Gjam4","gridContainer":"CategoriesList_gridContainer__r7Tjv"};